export default __webpack_public_path__ + "static/media/maure_de_bretagne6.dee26609.jpg";